import { gql } from '@apollo/client';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodePastedSubscription = gql`
  subscription surfaceNodePasted($surface: ID!, $user: ID!) {
    surfaceNodePasted(surface: $surface, user: $user) {
      ...surfaceNodeUnionDetails
    }
  }
  ${surfaceUnionFragment}
`;
